import React, { useMemo } from 'react';
import { currencyFormatter } from '../../utils/currencyFormatter';

const TabelaEspacamentoEventosPagamentoPropTemporalEmMeses = ({
  linhas = [],
  chaveCabecalhoLinhas = '',
  chaveValor = 'eventoPagamentoProp_vlr',
  valorTotal = 0,
  setValoresPorLinhaEColuna,
  valoresPorLinhaEColuna,
  setQuantidadeColunas,
  quantidadeColunas,
  chaveIdentificador,
  handleChangeQuantidadeColunas,
}) => {
  void setQuantidadeColunas;
  void handleChangeQuantidadeColunas;
  void setValoresPorLinhaEColuna;
  void valoresPorLinhaEColuna;

  const getLinhaKey = (linha, indiceLinha) => linha?.id ?? linha?.[chaveIdentificador] ?? indiceLinha;

  const indicesColunas = useMemo(
    () => Array.from({ length: quantidadeColunas }, (_, index) => index + 1),
    [quantidadeColunas]
  );

  const toNumber = (value) => {
    if (typeof value === 'number') return value;
    if (typeof value === 'string') {
      const normalized = value.replace(',', '.').trim();
      const parsed = Number(normalized);
      return Number.isNaN(parsed) ? 0 : parsed;
    }
    return 0;
  };

  const getIndiceColunaDoPrazo = (prazoRaw) => {
    const prazo = toNumber(prazoRaw);
    if (Number.isNaN(prazo) || prazo < 0) return null;
    if (prazo <= 30) return 1;
    return Math.ceil(prazo / 30);
  };

  const getValorMonetarioDoEvento = (linha) => {
    const percentual = toNumber(linha?.[chaveValor]);
    const total = toNumber(valorTotal);
    return (percentual / 100) * total;
  };

  const eventosPorColuna = useMemo(() => {
    const eventosAgrupados = indicesColunas.reduce((acc, indiceColuna) => {
      acc[indiceColuna] = [];
      return acc;
    }, {});

    linhas.forEach((linha, indiceLinha) => {
      const indiceColunaDoEvento = getIndiceColunaDoPrazo(linha?.eventoPagamentoProp_prazoPgto);
      if (!indiceColunaDoEvento || !eventosAgrupados[indiceColunaDoEvento]) return;

      eventosAgrupados[indiceColunaDoEvento].push({
        key: getLinhaKey(linha, indiceLinha),
        nome: linha?.[chaveCabecalhoLinhas] ?? '',
        valor: getValorMonetarioDoEvento(linha),
      });
    });

    return eventosAgrupados;
  }, [chaveCabecalhoLinhas, chaveIdentificador, indicesColunas, linhas, valorTotal, chaveValor]);

  const getValorTotalDaColuna = (indiceColuna) => {
    return (eventosPorColuna[indiceColuna] || []).reduce((soma, evento) => soma + evento.valor, 0);
  };

  return (
    <div style={{ overflow: 'auto' }}>
      <table style={{ borderCollapse: 'collapse', width: '100%' }}>
        <thead>
          <tr>
            {indicesColunas.map((indiceColuna) => (
              <th
                key={indiceColuna}
                style={{ border: '1px solid #ced4da', padding: '6px 8px', textAlign: 'center' }}
              >
                {indiceColuna}
              </th>
            ))}
          </tr>
        </thead>

        <tbody>
          <tr>
            {indicesColunas.map((indiceColuna) => {
              const eventosDaColuna = eventosPorColuna[indiceColuna] || [];

              return (
                <td
                  key={`coluna-eventos-${indiceColuna}`}
                  style={{
                    border: '1px solid #ced4da',
                    padding: '8px',
                    width: '10rem',
                    minWidth: '10rem',
                    verticalAlign: 'top',
                    backgroundColor: eventosDaColuna.length ? '#d1f7dd' : '#fff',
                  }}
                >
                  {eventosDaColuna.map((evento) => (
                    <div className="d-flex flex-column justify-content-between" style={{padding: '1rem 0'}}>
                      <div
                        key={evento.key}
                        style={{
                          textAlign: 'center',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        {evento.nome}
                      </div>
                      <div
                        key={evento.key}
                        style={{
                          textAlign: 'center',
                          fontSize: 12,
                          fontWeight: 600,
                        }}
                      >
                        {currencyFormatter.format(evento.valor)}
                      </div>
                    </div>
                  ))}
                </td>
              );
            })}
          </tr>
          <tr>
            {indicesColunas.map((indiceColuna) => (
              <td
                key={`total-coluna-${indiceColuna}`}
                style={{
                  border: '1px solid #ced4da',
                  padding: '6px 8px',
                  textAlign: 'center',
                  backgroundColor: '#f8f9fa',
                  fontWeight: 600,
                }}
              >
                {currencyFormatter.format(getValorTotalDaColuna(indiceColuna))}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default TabelaEspacamentoEventosPagamentoPropTemporalEmMeses;
